import { render } from "./TipButton.vue?vue&type=template&id=685c6e6a"
import script from "./TipButton.vue?vue&type=script&lang=js"
export * from "./TipButton.vue?vue&type=script&lang=js"
script.render = render

export default script